<template>
    <div class="d-flex flex-column justify-content-around align-items-center h-100 w-100 text-center bg-whitesmoke p-2">
        <div class="d-flex justify-content-center align-items-center">
            <b-img v-if="element.icone" height="20" width="20" :src="icon"/>
            <h5 class="text-primary my-0 font-weight-bold ml-1">{{element.name}}</h5>
        </div>
        <p class="my-1 text-justify px-2">{{element.value}}</p>
        <b-row class="w-100" no-gutters>
            <b-col cols="6" offset="3" md="4" offset-md="4">
                <b-btn
                        :to="element.link"
                       variant="primary"
                       class="w-100 btn--shadow"
                >
                    {{element.info}}
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import {APP_API_URL} from '@/utils/types/setting'

    export default {
        name: 'home-middle-news',
        props: {
            element: Object,
            type: String
        },
        data: () => ({
            apiOrigin: null,
            APP_API_URL
        }),
        computed: {
            icon() {
                return this.apiOrigin + this.element.icone
            }
        },
        mounted() {
            const {origin} = new URL(this.$store.state.base.setting[APP_API_URL])
            this.apiOrigin = origin
        }
    }
</script>
